import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@/lib/utils";

interface MarkdownProps {
  content: string;
  className?: string;
}

export function Markdown({ content, className }: MarkdownProps) {
  return (
    <div
      className={cn(
        "text-sm prose prose-sm dark:prose-invert max-w-none",
        "prose-p:my-1 prose-p:leading-relaxed",
        "prose-ul:my-1 prose-ol:my-1",
        "prose-li:my-0",
        "prose-headings:my-2",
        "prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:bg-muted prose-code:text-foreground prose-code:before:content-none prose-code:after:content-none",
        "prose-pre:my-2 prose-pre:p-3 prose-pre:rounded-lg prose-pre:bg-muted",
        "prose-a:text-primary-text prose-a:underline",
        "prose-strong:font-semibold",
        "prose-table:my-0",
        className
      )}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Wide tables scroll inside the message instead of spilling out of it.
          table: ({ node: _node, ...props }) => (
            <div className="my-2 overflow-x-auto">
              <table {...props} />
            </div>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
